import { Component } from '@angular/core';

@Component({
  selector: 'app-informative-page',
  templateUrl: './informative-page.component.html',
  styleUrl: './informative-page.component.scss'
})
export class InformativePageComponent {

}
